import repository from '@/utils/repository';

const resource = '/move/MNG_System006';

export default {
    getUserInfo: (data) => {
        return repository.post(`${resource}/getUserInfo`, {
            ...data
        });
    },
    store: (data) => {
        return repository.post(`${resource}/storeUserInfo`, {
            ...data
        });
    },
    getListTitle: () => {
        return repository.post(`${resource}/getListTitle`);
    },
    saveListKubun: (data) => {
        return repository.post(`${resource}/saveListKubun`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }
};
